<div class="media-title" *ngIf="game">
  {{ game.datetime | date: 'dd MMMM' }}
  <div class="count">
    <mtg-svg-icon icon="icons-media"></mtg-svg-icon>
    {{ images.length + videos.length }}
  </div>
</div>
<div class="media-content">
  <div class="sub-title" *ngIf="images.length > 0 && videos.length > 0">Видео</div>
  <mtg-game-media-video
    [game]="game"
    [video]="videos"
    [mediaRoute]="mediaRoute"
  ></mtg-game-media-video>
  <div class="sub-title" *ngIf="images.length > 0 && videos.length > 0">Фото</div>
  <mtg-game-media-images
    [game]="game"
    [images]="images"
    [mediaRoute]="mediaRoute"
  ></mtg-game-media-images>
</div>
<router-outlet></router-outlet>
